(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function(){
    const STOREFRONT_TOKEN = window.SHOPIFY_STOREFRONT_TOKEN || '2422b038552ba1706b7e37d3939127e9';
    const STOREFRONT_API = '/api/2025-10/graphql.json';

    if (!document.getElementById('coupon-apply')) return;

    let appliedCodeSuccess = "";
    let aftercouponprice = "";
    let countdownInterval;

    async function gql(query, variables) {
      const res = await fetch(STOREFRONT_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query, variables })
      });
      if (!res.ok) throw new Error('Network error');
      const json = await res.json();
      if (json.errors) throw new Error(json.errors.map(e => e.message).join('; '));
      return json.data;
    }

    const MUT_CREATE_CART = `
      mutation CreateCart($lines: [CartLineInput!]) {
        cartCreate(input: { lines: $lines }) {
          cart { id lines(first: 2) { edges { node { id } } } }
          userErrors { field message }
        }
      }
    `;
    const MUT_APPLY_CODE = `
      mutation ApplyDisc($cartId: ID!, $codes: [String!]!) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $codes) {
          cart {
            id
            discountCodes { code applicable }
            cost {
              subtotalAmount { amount currencyCode }
              totalAmount   { amount currencyCode }  # cart-level after discounts
            }
            lines(first: 10) {
              edges {
                node {
                  quantity
                  merchandise { ... on ProductVariant { id } }
                  cost {
                    amountPerQuantity { amount currencyCode }
                    subtotalAmount    { amount currencyCode } # before line discounts
                    totalAmount       { amount currencyCode } # after line discounts
                  }
                  discountAllocations {
                    discountedAmount { amount currencyCode }   # per-line allocations
                    targetType
                  }
                }
              }
            }
          }
          userErrors { field message }
        }
      }
    `;

    //UI HELPERS
    function animateNumber(el, from, to, ms) {
      el.classList.add('price-animating');
      const start = performance.now();
      const step = (now) => {
        const p = Math.min(1, (now - start) / ms);
        const eased = 1 - Math.pow(1 - p, 3);
        const val = from + (to - from) * eased;
        const compPrice = document.getElementById('price-block').dataset.comparePrice;
        const savingBlock = el.closest(".price__box_wrapper")?.querySelector(".sale__save--percent");
        if (compPrice && savingBlock) {
          const saving = (((Number(compPrice) / 100) - val.toFixed(2)) / (Number(compPrice) / 100)) * 100;
          savingBlock.textContent = `${parseInt(Math.abs(saving))}`;
        }
        
        el.textContent = "Rs. " + val.toFixed(2).replace(/\.00$/, '');
        if (p < 1) requestAnimationFrame(step);
        else el.classList.remove('price-animating');
      };
      requestAnimationFrame(step);
    }
    function setMsg(text, type='') {
      const msg = document.getElementById('coupon-msg');
      if (!msg) return;
      msg.textContent = text;
      msg.style.color = type === 'error' ? '#b00020' : (type === 'ok' ? '#0b7a0b' : 'inherit');
    }

    function startCountdown(duration, timerContainer, priceEl, originalPrice, discountedPrice) {
      if (countdownInterval) clearInterval(countdownInterval);

      const textEl = timerContainer.querySelector('#coupon-timer-text');
      const countdownEl = timerContainer.querySelector('#coupon-timer-countdown');
      const progressEl = timerContainer.querySelector('#coupon-timer-progress');

      let timer = duration, minutes, seconds;
      timerContainer.style.display = 'block';

      countdownInterval = setInterval(function () {
          minutes = parseInt(timer / 60, 10);
          seconds = parseInt(timer % 60, 10);

          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          
          textEl.textContent = 'Deal Expires in:';
          countdownEl.textContent = `${minutes}:${seconds}`;
          progressEl.style.width = (timer / duration * 100) + '%';

          if (--timer < 0) {
              clearInterval(countdownInterval);
              timerContainer.style.display = 'none';
              setMsg("Apply coupon again to lock in your price.", "");
              
              // Revert the price
              const priceBlock = document.getElementById('price-block');
              if (priceBlock && priceEl) {
                animateNumber(priceEl, discountedPrice, originalPrice, 900);
                priceBlock.dataset.price = originalPrice.toString();
              }
          }
      }, 1000);
    }

    //MAIN APPLY HANDLER
    document.getElementById('coupon-apply-btn')?.addEventListener('click', async () => {
      const code = document.getElementById('coupon-input').value.trim();
      const priceEl = document.querySelectorAll('#animated-price');
      const priceBlock = document.getElementById('price-block');
      if (!code) { setMsg('Please enter a code.'); return; }
      if (!priceEl.length || !priceBlock) { setMsg('Price element not found.', 'error'); return; }

      const variantGid = priceBlock.dataset.variantGid;
      const original = parseFloat(priceBlock.dataset.price);
      if (!variantGid || isNaN(original)) { setMsg('Variant/price missing.', 'error'); return; }

      if (!STOREFRONT_TOKEN) {
        setMsg('Storefront token not set. Please configure it.', 'error');
        return;
      }

      if (appliedCodeSuccess && code.toLowerCase() === appliedCodeSuccess.toLowerCase() && aftercouponprice==original) {
        setMsg('Coupon already applied.', 'ok');
        return;
      }

      setMsg('Validating…');

      try {
        // 1) Create temp cart
        const created = await gql(MUT_CREATE_CART, { lines: [{ merchandiseId: variantGid, quantity: 1 }] });
        const cartId = created?.cartCreate?.cart?.id;
        if (!cartId) throw new Error((created?.cartCreate?.userErrors||[]).map(u=>u.message).join(', ') || 'Cart create failed.');

        // 2) Apply discount
        const updated = await gql(MUT_APPLY_CODE, { cartId, codes: [code] });
        const cart = updated?.cartDiscountCodesUpdate?.cart;
        const applicable = cart?.discountCodes?.[0]?.applicable === true;

        // line for the variant
        const line = cart.lines.edges.find(e =>
            e.node.merchandise?.id === variantGid
          )?.node;
        if (!line) { setMsg('Line not found', 'error'); return; }

        const qty = line.quantity || 1;

        let unitAfter = parseFloat(line.cost.totalAmount.amount) / qty;

        const allocated = (line.discountAllocations || [])
          .reduce((s, a) => s + parseFloat(a.discountedAmount.amount), 0);

        if (!(unitAfter < original)) {
          const subtotal = parseFloat(line.cost.subtotalAmount.amount);
          const allocated = (line.discountAllocations || []).reduce((s, a) => s + parseFloat(a.allocatedAmount.amount), 0);
          unitAfter = (subtotal - allocated) / qty;
        }

        // animate
        if (unitAfter < original) {
          priceEl.forEach((e) => {
            animateNumber(e, original, unitAfter, 900);
            priceBlock.dataset.price = unitAfter.toString();
            setMsg(`Applied "${code}" ✓ | Unlocked Lowest Price Ever!`, 'ok');
            appliedCodeSuccess = code;
            aftercouponprice = unitAfter;
            __applyCouponToCartLinks(code);
  
            const timeinseconds = 300;
            const timerEl = document.getElementById('coupon-timer');
            startCountdown(timeinseconds, timerEl, e, original, unitAfter);
            launchCouponConfetti({
              originEl: document.getElementById('price-block'),
              duration : 1400,
              particleCount : 200,
              spread : 150,            // degrees around straight-up
              gravity : 0.14,         // px/frame^2 (CSS pixels; auto scaled)
              decay : 0.96,     // nice glow on bright themes
            });
          })
        } else {
          setMsg('This code does not reduce this item’s price.', 'error');
        }

        // 3) Ensure checkout honors it
        sessionStorage.setItem('pending_discount_code', code);
        document.querySelectorAll('a[href*="/cart"], a[href*="/checkout"]').forEach(a => {
          const u = new URL(a.href, location.origin);
          u.searchParams.set('discount', code);
          a.href = u.toString();
        });
      } catch (e) {
        console.error(e);
        setMsg('Could not validate this code. Please try again.', 'error');
      }
    });

    // ====== Keep price/variant in sync when options change ======
    // Your file already defines productPageVariant(variant, product).
    // We patch-in a listener so our datasets stay correct even if your theme re-renders the price.
    document.addEventListener('variant:changed', function(ev){
      const v = ev.detail && ev.detail.variant;
      if (!v) return;
      const priceBlock = document.getElementById('price-block');
      const priceEl = document.querySelectorAll('#animated-price');
      if (!priceBlock || !priceEl.length) return;

      const unitPrice = (v.price / 100);
      priceBlock.dataset.variantGid = 'gid://shopify/ProductVariant/' + v.id;
      priceBlock.dataset.price = unitPrice.toString();

      // Reset visible price to the base price when switching variants
      priceEl.forEach((e) => {
        e.textContent = "Rs. " + unitPrice.toFixed(2).replace(/\.00$/, '');
      })

      // Capture previous code before reset
      const previouslyApplied = appliedCodeSuccess;

      // Reset coupon state on variant change
      appliedCodeSuccess = "";
      aftercouponprice = "";
      setMsg('');
      if (countdownInterval) {
        clearInterval(countdownInterval);
        const timerEl = document.getElementById('coupon-timer');
        if (timerEl) timerEl.style.display = 'none';
      }

      // Auto-reapply if we had a code
      if (previouslyApplied) {
        setMsg('Updating for new selection...');
        // Small delay to let UI settle, then re-click
        setTimeout(() => {
          const btn = document.getElementById('coupon-apply-btn');
          if (btn) btn.click();
        }, 250);
      }
    });

  })();

  /** Persist & apply discount cart/checkout links **/
  (function(){
    // Call after success;
    function applyDiscountToLinks(code) {
      localStorage.setItem('fastrrCouponCode',code)
      document.cookie = "discount_code=" + code + "; path=/; max-age=31536000; SameSite=None; Secure";
      if (!code) return;

      // 1) Update all links
      document.querySelectorAll('a[href]').forEach(a => {
        const raw = a.getAttribute('href');
        if (!raw) return;
        let u;
        try { u = new URL(raw, location.origin); } catch { return; }

        if (/\/(cart|checkout)(\/|$)/i.test(u.pathname)) {
          u.searchParams.set('discount', code);
          a.setAttribute('href', u.toString());
        }
      });

      // 2) Intercept native checkout buttons (not anchor tags)
      document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(btn => {
        btn.dataset.discountCode = code;
        if (!btn.__discHandler) {
          btn.__discHandler = true;
          btn.addEventListener('click', function(e){
            // Let apps override if they set explicit href on parent
            const code = this.dataset.discountCode || sessionStorage.getItem('pending_discount_code');
            if (!code) return; // fall back to normal behavior

            // Hard redirect to checkout with discount
            e.preventDefault();
            const u = new URL('/checkout', location.origin);
            u.searchParams.set('discount', code);
            window.location.href = u.toString();
          }, {capture:true});
        }
      });

      // 3) For forms that POST to /cart, add hidden discount input (best-effort)
      document.querySelectorAll('form[action*="/cart"]').forEach(form => {
        let input = form.querySelector('input[name="discount"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'discount';
          form.appendChild(input);
        }
        input.value = code;
      });
    }

    // Re-apply when DOM updates (cart drawer opens, AJAX fragments render, etc.)
    function observeAndReapply(code) {
      if (!code) return;
      if (window.__discObserver) { window.__discObserver.disconnect(); }
      window.__discObserver = new MutationObserver(() => applyDiscountToLinks(code));
      window.__discObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Public hook you can call from your coupon success branch
    window.__applyCouponToCartLinks = function(code){
      try {
        sessionStorage.setItem('pending_discount_code', code);
        document.cookie = "discount_code=" + code + "; path=/; max-age=31536000; SameSite=None; Secure";
      } catch(e) {}
      applyDiscountToLinks(code);
      observeAndReapply(code);
    };

    // Auto-apply if a code was set earlier (navigating to PDP/cart later)
    document.addEventListener('DOMContentLoaded', () => {
      const persisted = sessionStorage.getItem('pending_discount_code');
      if (persisted) {
        applyDiscountToLinks(persisted);
        observeAndReapply(persisted);
      }
    });
  })();

  /* Robust confetti (no deps) — handles reduced-motion override and transformed ancestors. */
  (function () {
    function rnd(min, max){ return Math.random() * (max - min) + min; }
    function pick(arr){ return arr[(Math.random() * arr.length) | 0]; }

    window.launchCouponConfetti = function launchCouponConfetti(opts = {}) {
      const {
        originEl,
        origin,                 // {x,y} in viewport CSS pixels
        duration = 1400,
        particleCount = 140,
        spread = 70,            // degrees around straight-up
        gravity = 0.14,         // px/frame^2 (CSS pixels; auto scaled)
        decay = 0.92,
        colors = ['#26ccff','#a25afd','#ff5e7e','#88ff5a','#fcff42','#ffa62d','#ff36ff','#00c2a8','#ffd166','#ef476f'],
        shapes = ['ribbon','ribbon','paper','paper','star','circle','triangle','diamond'],
        ignoreReducedMotion = false,
        debug = false
      } = opts;

      // Respect reduced motion unless explicitly ignored
      if (!ignoreReducedMotion && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        if (debug) console.warn('[confetti] aborted due to prefers-reduced-motion');
        return;
      }

      // Create overlay canvas
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d', { alpha: true });
      canvas.style.position = 'fixed';
      canvas.style.left = '0';
      canvas.style.top = '0';
      canvas.style.width = '100vw';
      canvas.style.height = '100vh';
      canvas.style.pointerEvents = 'none';
      canvas.style.zIndex = '2147483647';
      document.body.appendChild(canvas);

      // Sizing with DPR-safe transform
      let dpr = Math.max(1, window.devicePixelRatio || 1);
      function sizeCanvas() {
        const rect = canvas.getBoundingClientRect(); // 100vw x 100vh in CSS px
        canvas.width = Math.round(rect.width * dpr);
        canvas.height = Math.round(rect.height * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0); // draw using CSS-pixel coordinates
        if (debug) console.log('[confetti] sized', { w: canvas.width, h: canvas.height, dpr });
      }
      sizeCanvas();

      const onResize = () => { dpr = Math.max(1, window.devicePixelRatio || 1); sizeCanvas(); };
      window.addEventListener('resize', onResize);

      // Compute origin (CSS pixels in viewport)
      let ox = window.innerWidth / 2, oy = window.innerHeight / 2;
      if (originEl && originEl.getBoundingClientRect) {
        const r = originEl.getBoundingClientRect();
        ox = r.left + r.width / 2;
        oy = r.top + r.height / 2;

        // --- FIX START: Clamp to Viewport ---
        // If element is below the visible screen, force start at bottom edge
        if (oy > window.innerHeight) {
          oy = window.innerHeight - 20; 
        }
        // If element is above the visible screen (scrolled past), force start at top edge
        else if (oy < 0) {
          oy = 20;
        }
        // --- FIX END ---

      } else if (origin) {
        if (typeof origin.x === 'number') ox = origin.x;
        if (typeof origin.y === 'number') oy = origin.y;
      }

      const parts = [];
      const half = Math.floor(particleCount / 2);
      function makeBurst(dir){ // dir = -1 (left) or +1 (right)
        for (let i=0;i<half;i++){
          const angle = (-90 + dir * rnd(0, spread)) * Math.PI/180;
          const v = rnd(6, 12);
          parts.push({
            x: ox, y: oy,
            vx: Math.cos(angle) * v,
            vy: Math.sin(angle) * v,
            size: rnd(6, 11),
            rot: rnd(0, Math.PI*2),
            vr: rnd(-0.25, 0.25),
            alpha: 1,
            color: pick(colors),
            shape: pick(shapes)
          });
        }
      }
      makeBurst(-1); makeBurst(1);

      const t0 = performance.now();
      let frames = 0;

      function tick(now){
        frames++;
        const t = now - t0;

        // Clear with identity transform to avoid precision issues
        ctx.setTransform(1,0,0,1,0,0);
        ctx.clearRect(0,0,canvas.width,canvas.height);
        ctx.setTransform(dpr,0,0,dpr,0,0);

        for (let i = parts.length - 1; i >= 0; i--) {
          const p = parts[i];
          // physics
          p.vx *= decay;
          p.vy = p.vy * decay + gravity;
          p.x += p.vx;
          p.y += p.vy;
          p.rot += p.vr;
          p.alpha = Math.max(0, 1 - t / duration);

          // draw
          ctx.globalAlpha = p.alpha;
          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;

          switch (p.shape || 'paper') {
            case 'ribbon': {
              // long thin rectangle
              const w = p.size * 1.2, h = p.size * 0.38;
              ctx.fillRect(-w*0.5, -h*0.5, w, h);
              break;
            }
            case 'paper':
            case 'square':
            case 'rect': {
              ctx.fillRect(-p.size/2, -p.size/2, p.size, p.size);
              break;
            }
            case 'diamond': {
              const s = p.size * 0.75;
              ctx.beginPath();
              ctx.moveTo(0, -s);
              ctx.lineTo(s, 0);
              ctx.lineTo(0, s);
              ctx.lineTo(-s, 0);
              ctx.closePath();
              ctx.fill();
              break;
            }
            case 'triangle': {
              const s = p.size;
              ctx.beginPath();
              ctx.moveTo(0, -s/1.15);
              ctx.lineTo(s/1.15, s/1.15);
              ctx.lineTo(-s/1.15, s/1.15);
              ctx.closePath();
              ctx.fill();
              break;
            }
            case 'star': {
              const r = p.size * 0.6, r2 = r * 0.5;
              ctx.beginPath();
              for (let i=0;i<5;i++){
                const a1 = (18 + i*72) * Math.PI/180;
                const a2 = (54 + i*72) * Math.PI/180;
                ctx.lineTo(Math.cos(a1)*r,  Math.sin(a1)*r);
                ctx.lineTo(Math.cos(a2)*r2, Math.sin(a2)*r2);
              }
              ctx.closePath();
              ctx.fill();
              break;
            }
            case 'circle': {
              ctx.beginPath();
              ctx.arc(0, 0, p.size*0.5, 0, Math.PI*2);
              ctx.fill();
              break;
            }
            default: {
              ctx.fillRect(-p.size/2, -p.size/2, p.size, p.size);
            }
          }

          ctx.restore();

          // cull
          if (p.alpha <= 0 || p.y - p.size > window.innerHeight + 40) parts.splice(i,1);
        }

        ctx.globalAlpha = 1;

        if (t < duration && parts.length) {
          requestAnimationFrame(tick);
        } else {
          window.removeEventListener('resize', onResize);
          canvas.remove();
          if (debug) console.log('[confetti] finished', { frames });
        }
      }

      requestAnimationFrame(tick);
      if (debug) console.log('[confetti] launched', { origin: {x:ox,y:oy}, count: parts.length });
    };
  })();


  (function () {
    // Logic to actually click the button
    function tryAutoApply() {
      var input = document.getElementById('coupon-input');
      var btn   = document.getElementById('coupon-apply-btn');
      if (!input || !btn) return false;

      var code = (input.value || '').trim();
      if (!code) return false;

      // Guard: Prevent double-clicking
      if (btn.dataset.autoClicked === '1') return true; 
      
      // Mark as clicked and fire event
      btn.dataset.autoClicked = '1';
      btn.click();
      return true;
    }

    function onReady(fn){
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, { once: true });
      } else {
        fn();
      }
    }

    onReady(function () {
      // 1. Populate input & Set Cookie IMMEDIATELY
      const sp = new URLSearchParams(location.search);
      const dcode = sp.get('discount') || sp.get('DISCOUNT');
      
      if (dcode) {
        // Clean the code (remove %20, +, etc)
        var cleanCode = decodeURIComponent(String(dcode).replace(/\+/g, ' '));
        
        // Update the input field visual
        var el = document.querySelector('#coupon-input');
        if (el) el.value = cleanCode;

        // Save to Storage & Cookie immediately (don't wait for scroll)
        localStorage.setItem('fastrrCouponCode', cleanCode);
        document.cookie = "discount_code=" + cleanCode + "; path=/; max-age=31536000; SameSite=None; Secure";
      } else {
        // Also check sessionStorage or localStorage for persisted code if no URL param
        const persisted = sessionStorage.getItem('pending_discount_code') || localStorage.getItem('fastrrCouponCode');
        if (persisted) {
          var el = document.querySelector('#coupon-input');
          if (el) el.value = persisted;
        }
      }

      // 2. Define the observer target
      var target = document.getElementById('coupon-apply');
      if (!target) return;

      // 3. Use IntersectionObserver to trigger ONLY when visible
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              // Element is now in view -> Trigger the click
              if (tryAutoApply()) {
                // If successfully clicked, stop observing so it doesn't run again
                observer.disconnect();
              }
            }
          });
        }, { threshold: 0.1 }); // Trigger when 10% of the element is visible

        observer.observe(target);
      } 
      else {
        // Fallback for very old browsers: just run after a delay
        setTimeout(tryAutoApply, 1500);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
